export function setupCanvas(canvas) {
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    return ctx;
};

export function photoSizeFormat({
    video,
    baseWith = 2000,
    baseHeight = 2000,
}) {
    let targetWidth;
    let targetHeight;
    if (video.width > baseWith && video.height > baseHeight) {
        const rate = Math.min(baseWith / video.width, baseHeight / video.height);
        targetWidth = video.width * rate;
        targetHeight = video.height * rate;
    } else if (video.width > baseWith) {
        targetWidth = baseWith;
        targetHeight = (baseWith / video.width) * video.height;
    } else if (video.height > baseHeight) {
        targetHeight = baseHeight;
        targetWidth = (baseHeight / video.height) * video.width;
    } else {
        targetWidth = video.width;
        targetHeight = video.height;
    }

    return {
        targetWidth,
        targetHeight,
    };
};

export function drawImage(video) {
    const canvas = document.createElement('canvas');
    let context;
    if (canvas.getContext) {
        context = setupCanvas(canvas);
    }

    // const {
    //     targetWidth,
    //     targetHeight,
    // } = photoSizeFormat({
    //     video: video,
    // });
    // canvas.width = targetWidth;
    // canvas.height = targetHeight;
    console.log({
        width: video.width,
        height: video.height,
        offsetWidth: video.offsetWidth,
        offsetHeight: video.offsetHeight,
    });
    canvas.width = video.width;
    video.height += 100;
    canvas.height = video.height;
    // context.drawImage(video, 0, 0, video.width, video.height, 0, 0, targetWidth, targetHeight);
    context.drawImage(video, 0, 0, video.width, video.height);
    // if (video.offsetWidth < video.offsetHeight) {
    //     context.rotate(90 * Math.PI / 180);
    // }
    return canvas;
}

export function saveImageToDataURL(video) {
    return drawImage(video).toDataURL('image/png');
};

export function saveImageToBlob(video) {
    return new Promise((resolve, reject) => {
        drawImage(video).toBlob((b) => {
            resolve(b);
        });
    });
};

export function closeVideo(video) {
    if (video) {
        try {
            video.src = '';
            video.pause();
            video.currentTime = 0;
            video.srcObject = null;
        } catch (ex) {
            console.log('closeVideo', ex);
        }
    }
}

export function closeRecordRTC(recorder) {
    if (recorder != null && recorder?.stream) {
        try {
            recorder.stopRecording();
            const tracks = recorder.stream.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
        } catch (ex) {
            console.error('closeStream', ex);
        }
    }
}

export function checkIsMobileDevice() {
    let result = false;
    const isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        iPhone: function () {
            return navigator.userAgent.match(/iPhone/i);
        },
        iPad: function () {
            return navigator.userAgent.match(/iPad/i);
        },
        any: function () {
            return (isMobile.Android() || isMobile.iPhone() || isMobile.iPad());
        },
    };

    // if ($(window).width() <= 767) {
    //     result = true;
    // }

    if (isMobile.any()) {
        result = true;
    }
    return result;
}
